/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["kxv-Telu",[["ఎ","పి"],["ఎ ఎమ్","పి ఎమ్"],["ఎ ఎమ్","పి ఎమ్"]],[["ఎ ఎమ్","పి ఎమ్"],u,["ఎ ఎమ్","పి ఎమ్"]],[["వా","న","మా","వు","ల","ను","సా"],["వారమి","నమారా","మాంగాడా","వుదారా","లాకివరా","నుక్ వరా","సానివరా"]],u,[["మా","గు","హి","బె","ల","రా","బా","బా","అ","ది","పా","పు"],["మాగ","గుండు","హిరెఇ","బెసెకి","లండి","రాత","బాన్దపాణా","బార్సి","అస్ర","దివెడి","పాండు","పుసు"]],u,[["క్రీపూ","క్రీశ"],u,["క్రీన్తు వూర్వం","క్రీస్తు సకం"]],0,[0,0],["d/M/yy","d MMM y","d MMMM y","EEEE, d MMMM y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1}, {0}",u,"{1} త {0}",u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##,##0.###","#,##0%","¤#,##,##0.00","#E0"],"INR","₹","భారతదేశ రూపాయి",{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
